import * as tp from 'io-ts-promise';
import axios from 'axios';
import { AxiosResponse } from 'axios';

import Data from '../../Data';
import Endpoints from '../endpoints';
import { getDataFromAxios } from '../common';
import { UserProfileResponse } from './response_models';

export const getProfile = (): Promise<AxiosResponse<UserProfileResponse>> => axios.get(Endpoints.users.PROFILE(), Data.async.authorisationHeaders());

export default async () => await getProfile().then(getDataFromAxios.get).then(tp.decode(UserProfileResponse));
